import useLocales from "hooks/useLocales";
import {
  Tooltip,
  FormGroup,
  FormControlLabel,
  Switch,
  Box,
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

export default function SwitchLabel({ hide, setHide }) {
  const { translate } = useLocales();
  return (
    <FormGroup>
      <Box sx={{ textAlign: "center" }}>
        <FormControlLabel
          control={<Switch checked={hide} />}
          onChange={() => setHide(!hide)}
          label={translate("Hide")}
        />
        <Tooltip title={translate("Play chords like a pro without help")} arrow>
          <InfoIcon fontSize="small" />
        </Tooltip>
      </Box>
    </FormGroup >
  );
}
